import ComponentModule from "@eisinc/Overrides/Components/ProductPrice";

export * from "@eisinc/Overrides/Components/ProductPrice";

export default ComponentModule;
